export enum MealFirstServiceSsrEnum {
  PDML = 'PDML',
  CHML = 'CHML',
  VLML = 'VLML',
  VGML = 'VGML',
  KSML = 'KSML',
  MOML = 'MOML',
  GFML = 'GFML',
  DBML = 'DBML',
}

export enum MealSecondServiceSsrEnum {
  SNML = 'SNML',
  CHMS = 'CHMS',
  VLMS = 'VLMS',
  VGMS = 'VGMS',
  KSMS = 'KSMS',
  MOMS = 'MOMS',
  GFMS = 'GFMS',
  DBMS = 'DBMS',
}

export const MealsSsrEnum = {
  ...MealFirstServiceSsrEnum,
  ...MealSecondServiceSsrEnum,
};

export type MealsSsrEnum = MealFirstServiceSsrEnum | MealSecondServiceSsrEnum;

export enum MealServiceType {
  FIRST_SERVICE = 'firstService',
  SECOND_SERVICE = 'secondService',
}

export enum LayoutForEnum {
  MEALS = 'MEALS',
  SEATS = 'SEATS',
  EXTRAS = 'EXTRAS',
}
